module.exports = __webpack_public_path__ + "static/media/loading.5c726e79.gif";